<div class="blank-layout-container justify-content-center">
  <div class="row">
    <div class="col-12 text-center">
      <mat-icon class="redirecting-icon" style="font-size: 50px; height: 50px; width: 50px">swap_calls</mat-icon>
      @if(showMessage) {
      <h6 class="f-s-16 m-b-30">{{ "Redirecting" | translate }}</h6>
      }
      @if(showButton) {
      <a mat-flat-button color="primary" (click)="reloadHome()">{{ "Go back to Home" | translate }}</a>
      }
    </div>
  </div>
</div>